module.exports = __webpack_public_path__ + "img/japan-flag.788ab29d.jpg";